import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCrown } from "@fortawesome/free-solid-svg-icons"

import * as classes from "../styles/sidebar.module.css"

const Sidebar = ({ handler, catSlug = "" }) => {
  const data = useStaticQuery(graphql`
    query {
      rkQty: allRankingJson(filter: { type: { eq: "qty" } }) {
        nodes {
          id
          title
          slug
        }
      }
      rkBrands: allRankingJson(filter: { type: { eq: "brands" } }) {
        nodes {
          id
          title
          slug
        }
      }
      rkOthers: allRankingJson(filter: { type: { eq: "others" } }) {
        nodes {
          id
          title
          slug
        }
      }
    }
  `)

  const openModalHandler = () => {
    handler()
  }
  return (
    <aside id="sidebar" className={classes.sidebar}>
      {catSlug && catSlug !== "online" && (
        <div className={`${classes.widgetMap} widget`}>
          <StaticImage
            src="../images/area-map.png"
            className={classes.widgetMap__img}
            alt="map"
            placeholder="blurred"
            width={640}
            height={480}
          />
          <div className="smb-btn-wrapper u-ta-c">
            <button
              className="smb-btn"
              onClick={openModalHandler}
              type="button"
            >
              地図で見る
            </button>
          </div>
        </div>
      )}
      <div className={`${classes.widget_nav_menu} c-widget`}>
        <div className={classes.widget__title}>
          <FontAwesomeIcon icon={faCrown} className="text-warning" />{" "}
          枚数別ランキング
        </div>
        <div>
          <ul className={classes.drawerNav}>
            {data.rkQty.nodes.map((node) => (
              <li key={node.id}>
                <Link to={`/ranking/${node.slug}/`}>{node.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={`${classes.widget_nav_menu} c-widget`}>
        <div className={classes.widget__title}>
          <FontAwesomeIcon icon={faCrown} className="text-warning" />{" "}
          ブランド別価格ランキング
        </div>
        <div>
          <ul className={classes.drawerNav}>
            {data.rkBrands.nodes.map((node) => (
              <li key={node.id}>
                <Link to={`/ranking/${node.slug}/`}>
                  {node.slug.toUpperCase()} <small>{node.title}</small>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={`${classes.widget_nav_menu} c-widget`}>
        <div className={classes.widget__title}>
          <FontAwesomeIcon icon={faCrown} className="text-warning" />{" "}
          テーマ別ランキング
        </div>
        <div>
          <ul className={classes.drawerNav}>
            {data.rkOthers.nodes.map((node) => (
              <li key={node.id} className={classes.drawerNav__item}>
                <Link to={`/ranking/${node.slug}/`}>{node.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={`${classes.widget_archive} c-widget`}>
        <Link to={`/diy-flocky-print/`}>
          <div>
            <StaticImage
              src="../../content/images/diy-flocky-print01.jpg"
              aspectRatio={1}
              alt="フロッキープリント"
              placeholder="blurred"
              width={70}
            />
          </div>
          <div className={classes.widget__item_body}>
            <p>
              <span className="badge bg-warning">プリント体験談</span>
              <br />
              フロッキープリントを自作してみた！
              <small className="text-blue">→ 記事を読む</small>
            </p>
          </div>
        </Link>
      </div>
      {/* <div className={`${classes.widget_archive} c-widget`}>
        <div className={classes.widget__title}>アクセスランキング</div>
        <ul>
          {data.allPageViews.nodes.map((node, i) => (
            <li key={node.id}>
              <Link to={`/companies/${node.slug}/`}>
                <div>
                  {node.markdownRemark.featuredImage.childImageSharp !==
                  null ? (
                    <GatsbyImage
                      image={
                        node.markdownRemark.featuredImage.childImageSharp
                          .gatsbyImageData
                      }
                      objectPosition="top 50%"
                      alt={node.markdownRemark.frontmatter.title}
                    />
                  ) : (
                    <StaticImage
                      src="../images/noimg.png"
                      objectPosition="top 50%"
                      alt="No image"
                      placeholder="blurred"
                      width={70}
                      height={70}
                    />
                  )}
                </div>
                <div className={classes.widget__item_body}>
                  <span className={`p-rankBadge p-rankBadge_${i + 1}`}>
                    {i + 1}
                  </span>
                  <div>{node.markdownRemark.frontmatter.title}</div>
                  <p className="text-gray small u-mt-5">
                    {node.markdownRemark.frontmatter.categories[0].title}
                  </p>
                  <div className="p-rating">
                    <div className="p-rating_avarage">
                      {node.markdownRemark.comments.length > 0 && (
                        <span
                          className="p-rating_avarage-stars"
                          style={{
                            width:
                              (node.markdownRemark.comments.reduce(
                                (sum, i) => sum + i.rating,
                                0
                              ) /
                                node.markdownRemark.comments.length) *
                                20 +
                              "%",
                          }}
                        />
                      )}
                    </div>
                    <span className="p-rating_avarage-num">
                      {node.markdownRemark.comments.length}
                      レビュー
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div> */}
      <div className={`${classes.a8} c-widget`}>
        <a
          href="https://px.a8.net/svt/ejp?a8mat=2BWAKX+7BR6EA+2TLI+5ZMCH"
          rel="nofollow"
        >
          <img
            border={0}
            width={300}
            height={250}
            alt=""
            loading="lazy"
            src="https://www29.a8.net/svt/bgt?aid=140914833443&wid=007&eno=01&mid=s00000013167001006000&mc=1"
          />
        </a>
        <img
          border={0}
          width={1}
          height={1}
          src="https://www11.a8.net/0.gif?a8mat=2BWAKX+7BR6EA+2TLI+5ZMCH"
          alt=""
          loading="lazy"
        />
        <a
          href="https://px.a8.net/svt/ejp?a8mat=3HG6SP+9LWZVM+4R54+5ZU29"
          rel="nofollow"
        >
          <img
            border={0}
            width={300}
            height={250}
            alt=""
            loading="lazy"
            src="https://www24.a8.net/svt/bgt?aid=210707305581&wid=007&eno=01&mid=s00000022180001007000&mc=1"
          />
        </a>
        <img
          border={0}
          width={1}
          height={1}
          src="https://www14.a8.net/0.gif?a8mat=3HG6SP+9LWZVM+4R54+5ZU29"
          alt=""
          loading="lazy"
        />
        <a
          href="https://px.a8.net/svt/ejp?a8mat=3BSXTC+8TXMG2+4LAK+609HT"
          rel="nofollow"
        >
          <img
            border={0}
            width={300}
            height={250}
            alt=""
            loading="lazy"
            src="https://www29.a8.net/svt/bgt?aid=201224496534&wid=007&eno=01&mid=s00000021422001009000&mc=1"
          />
        </a>
        <img
          border={0}
          width={1}
          height={1}
          src="https://www11.a8.net/0.gif?a8mat=3BSXTC+8TXMG2+4LAK+609HT"
          alt=""
          loading="lazy"
        />
      </div>
    </aside>
  )
}

export default Sidebar
